import { Injectable } from '@angular/core';

@Injectable()
export class TextParserService {
  parseTextContent(
    textTranslation: string,
    keyTranslation: string
  ): { type: string; content: string }[] {
    const textContent: { type: string; content: string }[] = [];
    const regex = /\{([^}]+)\}/g;
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = regex.exec(textTranslation)) !== null) {
      const normalText = this.mapNormalText(lastIndex, match.index, textTranslation);
      if (normalText) {
        textContent.push(normalText);
      }
      textContent.push({ type: 'link', content: match[1] });
      lastIndex = regex.lastIndex;
    }

    const remainingNormalText = this.mapNormalText(
      lastIndex,
      textTranslation.length,
      textTranslation
    );

    if (remainingNormalText) {
      textContent.push(remainingNormalText);
    }

    textContent.forEach((item) => {
      if (item.type === 'link') {
        item.content = item.content.replace('key', keyTranslation);
      }
    });

    return textContent;
  }

  private mapNormalText(
    start: number,
    end: number,
    textTranslation: string
  ): { type: string; content: string } | null {
    if (start !== end) {
      return {
        type: 'normal',
        content: textTranslation.substring(start, end),
      };
    }

    return null;
  }
}
